import { Faq, FaqByServiceIdInput, GetSessionsByServiceIdInput, Session, SuccessStory } from './../graphql/types/types';
import { SERVICE, SESSIONS_BY_SERVICE_ID, FAQ_BY_SERVICE_ID, SUCCESS_STORIES_BY_SERVICE_ID, GET_FQA_BY_SERVICE_ID } from './../graphql/queries/queries';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { SERVICES } from '../graphql/queries/queries';
import { GetServiceInput, PaginationOptions, Service } from '../graphql/types/types';

@Injectable({
	providedIn: 'root'
})
export class ServiceService {


	constructor(private apollo: Apollo) { }

	listServices(Obj: PaginationOptions) {
		return this.apollo.query<[Service]>({
			query: SERVICES,
			variables: { paginationOptions: Obj }
		})
	}


	listService(Obj: GetServiceInput) {
		return this.apollo.query<Service>({
			query: SERVICE,
			variables: { getServiceInput: Obj }
		})
	}

	listSesssionsByServiceId(Obj:GetSessionsByServiceIdInput){
		return this.apollo.query<Session>({
			query: SESSIONS_BY_SERVICE_ID,
			variables: { getSessionsByService: Obj }
		})
	}

	listSuccessStoriesByServiceId(Obj:FaqByServiceIdInput) {
		return this.apollo.query<SuccessStory>({
			query: SUCCESS_STORIES_BY_SERVICE_ID,
			variables: { getSuccessStoriesByServiceIdInput : Obj }
		})
	}

	listFAQByServiceId(Obj:FaqByServiceIdInput) {
		return this.apollo.query<Faq>({
			query: GET_FQA_BY_SERVICE_ID,
			variables: { getFaqByServiceIdInput: Obj }
		})
	}

}
